import { ReplenishmentTemplateListPage } from '@/features/replenishment-template/pages/ReplenishmentTemplateListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateListPage,
})
